import { render } from "./Index.vue?vue&type=template&id=3309e596"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=3309e596&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Customers/Teams/View/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3309e596"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3309e596', __exports__)) {
    api.reload('3309e596', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=3309e596", () => {
    api.rerender('3309e596', render)
  })

}


export default __exports__